import React, { useEffect, useState } from "react";
import { useIsPhone } from "@/lib/useIsPhone";
import { GoLiveItem } from "./GoLiveItem";

// On phones a group whose items are all ticked folds to one line.
export function GoLiveSection({ section, busy, onToggle, onRefresh }) {
  const phone = useIsPhone();
  const [expanded, setExpanded] = useState(false);
  const done = section.items.filter((i) => i.done).length;
  const finished = done === section.items.length;
  const folded = phone && finished && !expanded;
  useEffect(() => { if (!finished) setExpanded(false); }, [finished]);
  const id = `golive-section-${section.key}`;
  return (
    <div className="border-2 border-black p-3" data-testid={id} data-folded={folded ? "1" : "0"}>
      <div className="flex items-center gap-2">
        <span className="label-mono">{section.title}</span>
        <span className={`ml-auto text-[11px] uppercase tracking-widest ${finished ? "text-emerald-700" : "text-zinc-500"}`}
          data-testid={`${id}-count`}>
          {finished ? "All done" : `${done} of ${section.items.length} done`}
        </span>
        {phone && finished && (
          <button type="button" className="text-[11px] uppercase tracking-widest underline" onClick={() => setExpanded(!expanded)}
            data-testid={`${id}-fold`}>
            {folded ? "Show" : "Fold"}
          </button>
        )}
      </div>
      {!folded && <ul className="mt-1">{section.items.map((i) => <GoLiveItem key={i.key} item={i} busy={busy} onToggle={onToggle} onRefresh={onRefresh} />)}</ul>}
    </div>
  );
}
